import { Component, EventEmitter, Output } from '@angular/core';
import { AppComponent } from 'src/app/app.component';
import { PerfilAcessoService } from 'src/app/services/perfil-acesso.service';

@Component({
  selector: 'app-perfil-acesso-exclusao',
  templateUrl: './perfil-acesso-exclusao.component.html',
  styleUrls: ['./perfil-acesso-exclusao.component.scss']
})
export class PerfilAcessoExclusaoComponent {
  visivel: boolean = false;
  registro: any = {};
  validacoes: string[] = [];

  @Output()
  onSucesso: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    private app: AppComponent,
    private perfilAcessoService: PerfilAcessoService) {
  }

  abrir(registro: any) {
    this.visivel = true;
    this.registro = registro;
  }

  fechar() {
    this.visivel = false;
    this.registro = {};
    this.validacoes = [];
  }

  confirmar() {
    this.app.bloquearTela();
    this.validacoes = [];

    this.perfilAcessoService
      .excluir(this.registro.id)
      .subscribe(response => {
        this.app.desbloquearTela();

        if (response.sucesso) {
          this.onSucesso.emit(this.registro);
          this.fechar();
        } else {
          this.validacoes = response.mensagens!;
        }
      });
  }
}